// Arabic translations
const ar = {
  // Header translations
  transaction: 'المعاملة',
  prop: 'الدعم',
  explore: 'استكشف',
  profit: 'الربح',
  assets: 'الأصول',
  credit: 'الائتمان',
  balance: 'الرصيد',
  freeMargin: 'الهامش الحر',
  margin: 'الهامش',
  marginLevel: 'مستوى الهامش',
  openRealAccount: 'افتح حساب حقيقي',
  
  // Market Watch
  marketWatch: 'مراقبة السوق',
  favorites: 'المفضلة',
  mostActive: 'الأكثر نشاطاً',
  all: 'الكل',
  searchSymbols: 'البحث عن الرموز...',
  
  // Trading Actions
  buy: 'شراء',
  sell: 'بيع',
  close: 'إغلاق',
  
  // Trading Modal
  market: 'السوق',
  pending: 'معلق',
  lot: 'لوت',
  price: 'السعر',
  optional: 'اختياري',
  marketOrder: 'أمر السوق',
  pendingOrder: 'أمر معلق',
  executionPrice: 'سعر التنفيذ',
  cancel: 'إلغاء',
  
  // Positions Panel
  open: 'مفتوح',
  openPositions: 'المراكز المفتوحة',
  pending: 'معلق',
  pendingOrders: 'الأوامر المعلقة',
  closed: 'مغلق',
  closedPositions: 'المراكز المغلقة',
  finance: 'المالية',
  noOpenPositions: 'ليس لديك مراكز مفتوحة. ابدأ التداول لرؤية مراكزك المفتوحة هنا.',
  noPendingOrders: 'لا توجد أوامر معلقة.',
  noClosedPositions: 'لا توجد مراكز مغلقة.',
  noFinancialHistory: 'لا يوجد تاريخ مالي.',
  
  // Common terms
  symbol: 'الرمز',
  type: 'النوع',
  pnl: 'الربح/الخسارة',
  swap: 'المبادلة',
  commission: 'العمولة',
  spread: 'السبريد',
  time: 'الوقت',
  
  // Account info
  equity: 'رأس المال',
  usedMargin: 'الهامش المستخدم',
  accountBalance: 'رصيد الحساب',
  
  // Connection status
  connected: 'متصل',
  connecting: 'جاري الاتصال...',
  disconnected: 'غير متصل',
  
  // Mobile-specific translations
  accountSummary: 'ملخص الحساب',
  selectField: 'اختر الحقل',
  
  // Modal-specific translations
  buyOrder: 'أمر شراء',
  sellOrder: 'أمر بيع',
  
  // Navigation translations
  symbols: 'الرموز',
  chart: 'الرسم البياني',
  positions: 'المراكز',
  
  // Account management
  account: 'الحساب',
  notifications: 'الإشعارات',
  markAllRead: 'وضع علامة مقروء على الكل',
  noNotifications: 'لا توجد إشعارات',
  
  // Market Watch Settings Modal
  marketWatchSettings: 'إعدادات مراقب السوق',
  general: 'عام',
  display: 'العرض',
  generalSettings: 'الإعدادات العامة',
  displaySettings: 'إعدادات العرض',
  autoRefresh: 'التحديث التلقائي',
  autoRefreshDesc: 'تحديث الأسعار تلقائياً',
  soundAlerts: 'تنبيهات صوتية',
  soundAlertsDesc: 'تنبيهات صوتية لتغير الأسعار',
  updateInterval: 'فترة التحديث',
  second: 'ثانية',
  seconds: 'ثواني',
  showSpread: 'إظهار السبريد',
  showSpreadDesc: 'إظهار فرق العرض والطلب',
  showVolume: 'إظهار الحجم',
  showVolumeDesc: 'إظهار حجم التداول',
  decimalPlaces: 'الأرقام العشرية',
  colorTheme: 'موضوع الألوان',
  default: 'افتراضي',
  greenRed: 'أخضر-أحمر',
  blueOrange: 'أزرق-برتقالي',
  save: 'حفظ',

  // Technical Indicators
  indicators: 'المؤشرات',
  technicalIndicators: 'المؤشرات الفنية',
  sma20: 'متوسط متحرك بسيط 20',
  sma50: 'متوسط متحرك بسيط 50',
  ema12: 'متوسط متحرك أسي 12',
  ema26: 'متوسط متحرك أسي 26',
  rsi14: 'مؤشر القوة النسبية 14',
  bollingerBands: 'نطاقات بولينجر',
  movingAverage: 'المتوسط المتحرك',
  exponentialMovingAverage: 'المتوسط المتحرك الأسي',
  relativeStrengthIndex: 'مؤشر القوة النسبية',
  macd: 'مؤشر الماكد',
  stochastic: 'مؤشر ستوكاستيك',
  atr: 'متوسط المدى الحقيقي',
  volume: 'الحجم',
  
  // Chart loading states
  loadingChart: 'جاري تحميل الرسم البياني...',
  initializing: 'جاري التهيئة',
  chartReady: 'الرسم البياني جاهز',

  // Account creation
  createAccount: 'إنشاء حساب',
  newAccount: 'إنشاء حساب جديد',
  accountType: 'نوع الحساب',
  selectAccountType: 'اختر نوع الحساب',
  password: 'كلمة المرور',
  confirmPassword: 'تأكيد كلمة المرور',
  enterPassword: 'أدخل كلمة مرور الحساب',
  reenterPassword: 'أعد إدخال كلمة المرور',
  liveAccount: 'حساب حقيقي',
  demoAccount: 'حساب تجريبي',
  practiceAccount: 'حساب تدريبي',
  islamicAccount: 'حساب إسلامي',
  passwordMismatch: 'كلمات المرور غير متطابقة!',

  // Performance table
  performance: 'الأداء',
  performanceMetrics: 'مقاييس الأداء',
  totalTrades: 'إجمالي الصفقات',
  winningTrades: 'الصفقات الرابحة',
  losingTrades: 'الصفقات الخاسرة',
  winRate: 'معدل الفوز',
  totalProfit: 'إجمالي الربح',
  totalLoss: 'إجمالي الخسارة',
  netProfit: 'صافي الربح',
  averageWin: 'متوسط الربح',
  averageLoss: 'متوسط الخسارة',
  profitFactor: 'عامل الربح',
  maxDrawdown: 'أقصى انخفاض',
  consecutiveWins: 'أرباح متتالية',
  consecutiveLosses: 'خسائر متتالية',
  totalVolume: 'إجمالي الحجم',
  tradingHistory: 'سجل التداول',
  loading: 'جاري التحميل...',
  noTradeHistory: 'لا يوجد سجل تداول',

  // Positions table specific translations
  id: 'المعرف',
  amount: 'الكمية',
  openTime: 'وقت الفتح',
  openPrice: 'سعر الفتح',
  closePrice: 'سعر الإغلاق',
  stopLoss: 'وقف الخسارة',
  takeProfit: 'جني الأرباح',
  actions: 'الإجراءات',
  edit: 'تعديل',
  searchSymbol: 'البحث عن رمز...',
  loadingPositions: 'جاري تحميل المراكز...',
  trading: 'التداول',
  orders: 'الأوامر',
  history: 'السجل',
  openPositionsAndPending: 'المراكز المفتوحة والمعلقة',
  previous: 'السابق',
  next: 'التالي',
  page: 'الصفحة',
  of: 'من',
  noData: 'لا توجد بيانات',
  items: 'عناصر',
  itemsPerPage: 'عناصر لكل صفحة',
  
  // Orders specific translations
  orderType: 'نوع الأمر',
  orderPrice: 'سعر الأمر',
  currentPrice: 'السعر الحالي',
  placed: 'تم الوضع',
  expires: 'تنتهي',
  gtc: 'صالح حتى الإلغاء',
  noOrdersAvailable: 'لا توجد أوامر معلقة',
  
  // Chart specific translations
  trendLine: 'خط الاتجاه',
  dynamicTrend: 'الاتجاه الديناميكي',
  
  // Loading states
  loadingSymbols: 'جاري تحميل الرموز...',
  noSymbolsFound: 'لم يتم العثور على رموز',
  
  // Register/Login translations
  'Personal Information': 'المعلومات الشخصية',
  'Account Preferences': 'تفضيلات الحساب',
  'Verification': 'التحقق',
  'Create Your Zonex Account': 'إنشاء حساب Zonex الخاص بك',
  'Join the professional trading platform': 'انضم إلى منصة التداول الاحترافية',
  'First name is required': 'الاسم الأول مطلوب',
  'Last name is required': 'اسم العائلة مطلوب',
  'Email is required': 'البريد الإلكتروني مطلوب',
  'Please enter a valid email address': 'الرجاء إدخال عنوان بريد إلكتروني صالح',
  'Phone number is required': 'رقم الهاتف مطلوب',
  'Password is required': 'كلمة المرور مطلوبة',
  'Password must be at least 8 characters': 'يجب أن تتكون كلمة المرور من 8 أحرف على الأقل',
  'Passwords do not match': 'كلمات المرور غير متطابقة',
  'Please select your trading experience level': 'يرجى اختيار مستوى خبرتك في التداول',
  'You must agree to the Terms of Service': 'يجب عليك الموافقة على شروط الخدمة',
  'You must agree to the Privacy Policy': 'يجب عليك الموافقة على سياسة الخصوصية',
  'ID document is required': 'وثيقة الهوية مطلوبة',
  'Proof of address is required': 'إثبات العنوان مطلوب',
  'Registration failed': 'فشل التسجيل',
  'Registration successful! Please check your email to verify your account.': 'تم التسجيل بنجاح! يرجى التحقق من بريدك الإلكتروني للتحقق من حسابك.',
  'Please check your email and click the verification link.': 'يرجى التحقق من بريدك الإلكتروني والنقر على رابط التحقق.',
  'Previous': 'السابق',
  'Next': 'التالي',
  'Creating Account...': 'جاري إنشاء الحساب...',
  'Create Account': 'إنشاء حساب',
  'Already have an account?': 'هل لديك حساب بالفعل؟',
  'Sign in here': 'سجل الدخول هنا',
  'Registration failed. Please try again.': 'فشل التسجيل. يرجى المحاولة مرة أخرى.',
  
  // 404 Page
  pageNotFound: 'الصفحة غير موجودة',
  pageNotFoundMessage: 'الصفحة التي تبحث عنها غير موجودة. دعنا نعيدك!',
  goBack: 'العودة',
  backToHome: 'العودة إلى الصفحة الرئيسية',
  
  // Toast messages
  orderPlaced: 'تم تقديم الأمر',
  orderFailed: 'فشل الأمر. يرجى المحاولة مرة أخرى.',
  orderSuccess: 'تم تقديم الأمر بنجاح',
  positionClosed: 'تم إغلاق المركز',
  positionCloseFailed: 'فشل إغلاق المركز',
  orderCancelled: 'تم إلغاء الأمر',
  orderCancelFailed: 'فشل إلغاء الأمر',
  positionUpdated: 'تم تحديث المركز',
  positionUpdateFailed: 'فشل تحديث المركز',
  positionsClosed: 'مراكز تم إغلاقها',
  ordersCancelled: 'أوامر تم إلغاؤها',
  bulkCloseFailed: 'فشل الإغلاق الجماعي',
  bulkCancelFailed: 'فشل الإلغاء الجماعي',
  noPositionsSelected: 'لم يتم تحديد مراكز',
  noOrdersSelected: 'لم يتم تحديد أوامر',
  
  // Edit position
  editPosition: 'تعديل المركز',
  selected: 'محدد',
  closeSelected: 'إغلاق المحددة',
  clearSelection: 'مسح التحديد',
  
  // Partial close
  partialClose: 'إغلاق جزئي',
  volumeToClose: 'الحجم المراد إغلاقه',
  closePercentage: 'نسبة الإغلاق',
  remaining: 'المتبقي',
  closing: 'الإغلاق',
  estimatedProfit: 'الربح المقدر',
  invalidVolume: 'حجم غير صالح',
  volumeTooHigh: 'لا يمكن أن يتجاوز الحجم المبلغ الإجمالي',
  partialCloseFailed: 'فشل الإغلاق الجزئي',
  closePosition: 'إغلاق المركز',
  partial: 'جزئي',
  opened: 'تم الفتح',
  closed: 'تم الإغلاق',
  closeTime: 'وقت الإغلاق',
  
  // Finance tab
  financeSection: 'قسم المالية',
  financeSectionDesc: 'سيتم عرض المعاملات المالية وأنشطة الحساب هنا',
  description: 'الوصف',
  reference: 'المرجع',
  status: 'الحالة',
  completed: 'مكتمل',
  failed: 'فشل',
  date: 'التاريخ',
  noTransactions: 'لم يتم العثور على معاملات',
  
  // Symbol Categories
  fx: 'العملات',
  crypto: 'العملات الرقمية',
  popular: 'الشائع',
  stocks: 'الأسهم',
  commodities: 'السلع',
  indices: 'المؤشرات',
  price: 'السعر',
  
  // Chart Types
  lineChart: 'مخطط خطي',
  barChart: 'مخطط شريطي',
  candlestickChart: 'مخطط الشموع',
  zoomIn: 'تكبير',
  zoomOut: 'تصغير',
  resetZoom: 'إعادة تعيين',
  
  // Order Messages
  positionOpened: 'تم فتح المركز',
  orderPending: 'تم إنشاء أمر معلق',
  
  // Indicators
  indicators: 'المؤشرات',
  technicalIndicators: 'المؤشرات الفنية',
  indicatorsSelected: 'المؤشرات المحددة',
  period: 'الفترة',
  stdDev: 'الانحراف المعياري',
  apply: 'تطبيق',
  enableIndicator: 'تفعيل المؤشر',
  enabled: 'مفعل',
  disabled: 'معطل',
  parameters: 'المعاملات',
  color: 'اللون',
  selectIndicator: 'اختر مؤشراً',
  clear: 'مسح',
  add: 'إضافة',
  quickTrade: 'تداول سريع',
  quickTradeActive: 'التداول السريع نشط',
  quickTradeInactive: 'التداول السريع غير نشط',
  
  // Header Mobile
  language: 'اللغة',
  appearance: 'المظهر',
  darkMode: 'الوضع الداكن',
  lightMode: 'الوضع الفاتح',
  inbox: 'صندوق الوارد',
  noMessages: 'لا توجد رسائل',
  noMessagesDescription: 'ليس لديك رسائل في الوقت الحالي. قد تستغرق بعض الإشعارات وقتًا حتى تظهر. يرجى التحقق مرة أخرى لاحقًا.',
  support: 'الدعم',
  announcement: 'الإعلانات',
  noSupportMessages: 'لا توجد رسائل دعم',
  noSupportMessagesDesc: 'لا توجد طلبات دعم حتى الآن.',
  noAnnouncements: 'لا توجد إعلانات',
  noAnnouncementsDesc: 'لا توجد إعلانات حتى الآن.',
  noFinanceMessages: 'لا توجد إشعارات مالية',
  noFinanceMessagesDesc: 'لا توجد إشعارات معاملات مالية حتى الآن.',
  justNow: 'الآن',
  new: 'جديد',
  completed: 'مكتمل',
  equity: 'حقوق الملكية',
  leverage: 'الرافعة المالية',
  settings: 'الإعدادات',
  createNewTradingAccount: 'إنشاء حساب تداول جديد',
  minPasswordLength: 'الحد الأدنى 8 أحرف مطلوب',
  realAccount: 'حساب حقيقي',
  tradeWithRealMoney: 'تداول بأموال حقيقية',
  practiceWithVirtualMoney: 'تدرب بأموال افتراضية',
  accountFeatures: 'ميزات الحساب',
  standardAccount: 'حساب قياسي',
  standardFeatures: 'ميزات قياسية',
  swapFree: 'خالي من السواب',
  premiumSupport: 'دعم مميز',
  zeroCommission: 'بدون عمولة',
  vipAccount: 'حساب VIP',
  noCommissionAccount: 'حساب بدون عمولة',
  selectLeverage: 'اختر الرافعة المالية',
  leverageWarning: 'الرافعة المالية العالية تنطوي على مخاطر عالية',
  minimumDeposit: 'الحد الأدنى للإيداع',
  maximumLeverage: 'الحد الأقصى للرافعة المالية',
  free: 'مجاني',
  pleaseSelectAccountType: 'الرجاء تحديد نوع الحساب',
  pleaseSelectAccountFeatures: 'الرجاء تحديد ميزات الحساب',
  accountCreatedSuccessfully: 'تم إنشاء الحساب بنجاح'
};

export default ar;